import { render, staticRenderFns } from "./OnboardingCreateWorkspaceForm.vue?vue&type=template&id=a521539c&"
import script from "./OnboardingCreateWorkspaceForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingCreateWorkspaceForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCreateWorkspaceForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports